export default {
  pt: {
    pageTitle: "Qual o seu plano?",
    description: "Veja abaixo o plano de seguro incluso com sua {brand} e a opção de upgrade!",
    exclusiveOffer: "OFERTA EXCLUSIVA",
    offer: "OFERTA",
    upgradeTitle: "Upgrade de Quebra",
    freeInsuranceText: "Seguro Grátis {brand}",
    insuranceNote: "Seguro por 1 ano com reposição da bicicleta por outra ou similar",
    youSaveText: "Você economiza {value}",
    contractButton: "Contratar",
    detailsButton: "Detalhes",
  },

  en: {
    pageTitle: "What's your plan?",
    description: "See below the insurance plan included with your {brand} and the upgrade option!",
    exclusiveOffer: "EXCLUSIVE OFFER",
    offer: "OFFER",
    upgradeTitle: "Break Upgrade",
    freeInsuranceText: "Free Insurance {brand}",
    insuranceNote: "Insurance for 1 year with bicycle replacement by another or similar",
    youSaveText: "You save {value}",
    contractButton: "Contract",
    detailsButton: "Details",
  },
}; 